import { useQueryStates } from 'nuqs'
import { useCallback } from 'react'
import { parseAsZonedDate } from 'lib/nuqs/parseAsZonedDate'

export const useTimeRangeQueryState = () => {
  const [state, setState] = useQueryStates(
    {
      startDate: parseAsZonedDate,
      endDate: parseAsZonedDate,
    },
    {
      urlKeys: {
        startDate: 'start-date',
        endDate: 'end-date',
      },
    }
  )
  const set = useCallback(
    (value: { startDate?: Date | null; endDate?: Date | null }) =>
      setState({
        startDate: value?.startDate ?? null,
        endDate: value?.endDate ?? null,
      }),
    [setState]
  )

  const queryState = {
    startDate: state.startDate ?? undefined,
    endDate: state.endDate ?? undefined,
  }

  return [queryState, set] as const
}
